// extracted by mini-css-extract-plugin
export var banner = "_15-0";
export var icon = "_15-1";
export var message = "_15-2";